export enum SocialMediaPlatform {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  YOUTUBE = "YOUTUBE",
  LINKEDIN = "LINKEDIN",
  TIKTOK = "TIKTOK",
  PINTEREST = "PINTEREST",
  TELEGRAM = "TELEGRAM",
  X = "X"
}
